const ARABIC_INDIC_DIGITS = "٠١٢٣٤٥٦٧٨٩";

/**
 * Keep all numbers presented in Arabic copy visually consistent. Internal IDs
 * and URLs retain their ASCII digits; this is only for rendered text.
 */
export function toArabicDigits(value) {
  return String(value).replace(/[0-9]/g, (digit) =>
    ARABIC_INDIC_DIGITS[digit]
  );
}
